import { render, staticRenderFns } from "./iconDotMenu.vue?vue&type=template&id=5ba3e506&scoped=true"
import script from "./iconDotMenu.vue?vue&type=script&lang=js"
export * from "./iconDotMenu.vue?vue&type=script&lang=js"
import style0 from "./iconDotMenu.vue?vue&type=style&index=0&id=5ba3e506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3e506",
  null
  
)

export default component.exports